<template>
  <div class="campaignReportEdit">
    <div class="campaignReportEdit__header">
      <h1 class="medium-title">Edit Measurement</h1>
    </div>
    <div class="campaignReportEdit__body">
      <div class="campaignReportEdit__body__left">
        <div class="campaignReportEdit__body__left__form">
          <div class="campaignReportEdit__body__left__form__container">
            <h1 class="subhead">Detail Information</h1>
            <div class="campaignReportEdit__body__left__form__container__type">
              <adx-select-dropdown :label="`Measurement Type`" :options="type" :class="['dropdown', error.measurementType ? 'warning' : '']" :value.sync="model.measurement_type"/>
              <div v-if="error.measurementType" class="error-message">{{validation.errorMessage}}</div>
            </div>
            <div class="campaignReportEdit__body__left__form__container__campaign">
              <adx-input type="text" :label="`Select Campaign`" :value.sync="currentCampaign" :disabled="true" />
            </div>
          </div>
          <div class="campaignReportEdit__body__left__form__container">
            <div class="campaignReportEdit__body__left__form__container__listing">
              <h1 class="subhead">Location</h1>
              <template v-if="locations.length > 0">
                <div v-for="(list, index) in model.listing" :key="index" class="campaignReportEdit__body__left__form__container__listing__cut">
                  <div class="top">
                    <div><adx-single-search-dropdown :label="'Select Line Item'" :optionsParam="locations" :class="['dropdown', error.locations ? 'warning' : '']" :value.sync="list.location"/></div>
                    <div class="icon-wrapper"><i @click="deleteListing(model.listing, index)" class="icon-deleted"></i></div>
                  </div>
                </div>
              </template>
              <div v-if="error.locations" class="error-message">{{validation.errorMessage}}</div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addListing(model.listing)" class="new">Add new</button>
              </div>
            </div>
          </div>
        </div>
      </div>  
      <div class="campaignReportEdit__body__right">
        <div class="campaignReportEdit__body__right__detail">
          <h1 class="subhead">Campaign Detail</h1>
          <div class="campaignReportEdit__body__right__detail__wrapper">
            <div class="campaignReportEdit__body__right__detail__wrapper__left">
              <span>Price</span>
              <span>Total Listing</span>
            </div>
            <div class="campaignReportEdit__body__right__detail__wrapper__right">
              <p>{{ price | formatMoney }}</p>
              <p>{{ total_locations }}</p>
            </div>
          </div>
        </div>
        <div class="button-div">
          <button class="btn-large primary" 
            @click="updateCampaign()">Save
          </button>
          <adx-loading-white v-if="loadingSave" class="loading-circle" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Checkbox from '@/components/Form/Checkbox'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'
import LoadingSpinner from '@/components/Loading/Secondary-white'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import obj2fd from 'obj2fd'

export default {
  name: 'adx-add-new-campaign',
  components: {
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-dropdown-list': ListDropdown,
    'adx-checkbox': Checkbox,
    'adx-single-search-dropdown': SingleSearchDropdown,
    'adx-loading-white': LoadingSpinner,
  },
  props: {

  },
  data() {
    return {
      isInitial: true,
      loadingSave: false,
      routeID: null,
      adx: 'Adx',
      price: 0,
      total_locations: 0,
      validation: null,
      currentCampaign: null,
      model: {
        campaign: null,
        location_detail: null,
        measurement_type: null,
        price: null,
        impact: false,
        listing: [
          {
            location: null
          }
        ]
      },
      locations: [],
      campaign: [],
      listing: [],
      type: [
        {
          'id': 0,
          'label': 'Digital Screen Measurement',
          'value': 'digital_screen'
        },
      ],
      error: {
        measurementType: null,
        campaign: null,
        locations: null
      },
    }
  },
  computed: {
  },
  watch: {
    'model.campaign': function () {
        this.getLocationList()
    }
  },

  beforeCreate() {

  },
  created() {
    this.getDropdownOptions();
  },
  beforeMount() {
    
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    transformLocation(locations = []) {
      return locations.map(x => x.location)
    },

    getCampaignList() {
      (async () => {
        let dataCampaign = null
          const { status, data } = await api.get(apiV2.  measurementcampaignReportNoPage, { needToken: true })
          dataCampaign = data
          let campaign = dataCampaign.map(list => {
          return {
            label: `${list.title} ${list.owner}`,
            value: list.id
          }
        })
        this.campaign = campaign
        if (this.$route.query.id) {
          this.routeID = this.$route.query.id
          await this.getDataCampaign();
        }
      })();
    },

    getLocationList() {
      (async () => {
        const { data } = await api.get(apiV2.measurementGetLocations(this.model.campaign), { needToken: true })

        this.locations.length = 0
        
        data.locations.map(list => {
          this.locations.push({
            label: list.location_name,
            value: list.location_inside
          })
        })
        this.price = data.total_price,
        this.total_locations = data.count
      })();
    },

    getDataCampaign() {
      (async () => {
        const { data } = await api.get(apiV2.measurementGetCampaignReport(this.routeID), { needToken: true })
        this.model.measurement_type = data.measurement_type
        this.model.campaign = data.campaign
        this.model.listing = data.locations
        this.model.impact = data.is_impact

        for(var i=0; i<this.campaign.length; i++) {
          if(this.campaign[i].value == this.model.campaign) {
            this.currentCampaign = this.campaign[i].label
          }
        }
      })();
    },

    updateCampaign() {
      const data = {
        measurement_type: this.model.measurement_type,
        campaign: this.model.campaign,
        locations: this.model.listing,
        is_impact: this.model.impact,
        id: this.routeID
      }
      this.validation = this.inputValidation(data)
      if (this.validation.isValid) {
        (async () => {
          this.loadingSave = true
          const response = await api.put(apiV2.measurementGetCampaignReport(this.routeID), data,  { needToken: true })
          if (response.status == 200) {
            this.$notify({
              group: 'saved',
              title: 'Campaign updated',
              type: 'success'
            });
            this.$router.push({ name: 'allcampaign' })
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: response.data.error,
              type: 'warn'
            });
          }
          this.loadingSave = false
        })();
      } else {
        this.raiseError(this.validation.errorMessage)
      }
    },

    inputValidation(input) {
      let data = { isValid: true, errorMessage: null }
      let isValid = true
      this.error = {
        measurementType: null,
        campaign: null,
        locations: null
      }
      if (input.measurement_type == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Measurement type empty"
        this.error.measurementType = true
        isValid = false
      } else if (input.campaign == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Campaign empty"
        this.error.campaign = true
        isValid = false
      }
      if (isValid && input.locations.length > 0) {
        for (var i =0; i < input.locations.length && isValid; i++) {
          if (input.locations[i].location == null) {
            data.isValid = false
            data.errorMessage = "You can't leave Location empty"
            this.error.locations = true
            isValid = false
          }
          for (var j=i+1; j < input.locations.length; j++){
            if (input.locations[i].location == input.locations[j].location) {
              data.isValid = false
              data.errorMessage = "Location is already exists."
              this.error.locations = true
              isValid = false
            }
          }
        }
      }
      return data
    },

    raiseError(errorMessage) {
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    },

    selectCut(value, purpose){
    },
    
    getDropdownOptions() {
      this.getCampaignList()
    },

    addListing(listing) {
      listing.push(
        {
          location: null
        }
      )
    },

    deleteListing(listing, index) {
      if (listing.length > 1) {
        listing.splice(index, 1)
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.campaignReportEdit {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }
          }
        }
      }
    }
  }

  input {
    min-height: 62px;
  }

  .selectDropdown {
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .btn-regular {
    min-width: 97px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }

  .popup {
    &__input {
      &__dropdown {
        min-height: 24px;
      }
    }
  }
}
</style>
